import { camelize } from 'inflected';

export default function mapMenuItems(items, baseKey = null) {
    return items.map((id) => {
        const onClickKey = `on${camelize(id)}Click`;

        const fn = props => ({
            id: baseKey ? `${baseKey}.${id}` : null,
            action: id,
            key: onClickKey,
            onClick: (e) => { props[onClickKey](e); },
            isEnabled: typeof props[onClickKey] !== 'undefined',
        });

        return fn;
    });
}
